import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { TransactionType } from "./transaction-type";

export class TransactionLineTemplate extends Resource {
    public override type = 'transactionLineTemplates';

    @prop()
    @required()
    public transactionTypeId!: string;

    @propObject(TransactionType)
    public transactionType!: TransactionType;
 
    @prop()
    @required()
    public name!: string;

    @prop()    
    public configuration!: string;

}